module.exports = __webpack_public_path__ + "img/fo.275f04c8.svg";